import services from './services';

export default {
  namespaced: true,
  modules: {
    services,
  },
};
